import React, { useEffect, useState } from 'react';
import { Table, Spin } from 'antd';
import { Bar, Pie } from 'react-chartjs-2';
import { coberturavacunacion, mortalidadinfantil, seguramientosalud, tasamortalidad } from '../../../services/perfiles/conponentesServices';
import './tablaG.css';
const columns = [
  {
    title: 'Tipo de Registro',
    dataIndex: 'tipo',
    key: 'tipo',
    className: 'filaP',
  },
  {
    title: 'Cantidad',
    dataIndex: 'cantidad',
    key: 'cantidad',
    className: 'filaP',
  },
  {
    title: 'Porcentaje',
    dataIndex: 'porcentaje',
    key: 'porcentaje',
    className: 'filaP',
  },
];

const mortalityColumns = [
  {
    title: 'Nivel',
    dataIndex: 'nivel',
    key: 'nivel',
    className: 'filaP',
  },
  {
    title: 'Porcentaje',
    dataIndex: 'porcentaje',
    key: 'porcentaje',
    className: 'filaP',
  },
];
const infantMortalityColumns = [
  {
    title: 'Nivel',
    dataIndex: 'nivel',
    key: 'nivel',
    className: 'filaP',
  },
  {
    title: '%',
    dataIndex: 'porcentaje',
    key: 'porcentaje',
    className: 'filaP',
  },
];
const vaccinationCoberageColumns = [
  {
    title: 'Nivel',
    dataIndex: 'nivel',
    key: 'nivel',
    className: 'filaP',
  },
  {
    title: 'Porcentaje',
    dataIndex: 'porcentaje',
    key: 'porcentaje',
    className: 'filaP',
  },
];

const SaludComponente = ({ municipioId }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fuente, setFuente] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [year] = useState(new Date().getFullYear());
  const [mortalityData, setMortalityData] = useState([]);
  const [infantMortalityData, setInfantMortalityData] = useState([]);
  const [vaccinationCoverageData, setVacunationCoberageData] = useState([]);

  useEffect(() => {
    if (municipioId) {
      fetchData();
      fetchMortalityData();
      fetchInfantMortalityData(); // Añade esta línea
      fetchcoberturavacunacionData();
    }
  }, [municipioId]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await seguramientosalud(municipioId);

      const aseguramientoData = response.data[0];

      setData([
        {
          key: '1',
          tipo: 'Afiliados Régimen Contributivo',
          cantidad: aseguramientoData.afiliados_reg_contri.toLocaleString(),
          porcentaje: `${aseguramientoData.porc_afiliados_reg_contri}%`,
        },
        {
          key: '2',
          tipo: 'Afiliados Régimen Subsidiado',
          cantidad: aseguramientoData.afiliados_reg_sub.toLocaleString(),
          porcentaje: `${aseguramientoData.porc_afiliados_reg_sub}%`,
        },
        {
          key: '3',
          tipo: 'Afiliados Régimen Especial',
          cantidad: aseguramientoData.afiliados_reg_especial.toLocaleString(),
          porcentaje: `${aseguramientoData.porc_afiliados_reg_especial}%`,
        },
      ]);
      setFuente(aseguramientoData.fuente);
      setDescripcion(aseguramientoData.nombre_componente);
      setLoading(false);
    } catch (error) {
      console.error('Error obteniendo los datos', error);
      setLoading(false);
    }
  };

  const fetchMortalityData = async () => {
    setLoading(true);
    try {
      const response = await tasamortalidad(municipioId);

      const mortalityData = response.data[0];

      setMortalityData([
        {
          key: '1',
          nivel: 'Colombia',
          porcentaje: `${mortalityData.colombia}%`,
        },
        {
          key: '2',
          nivel: 'Cauca',
          porcentaje: `${mortalityData.cauca}%`,
        },
        {
          key: '3',
          nivel: 'Municipio',
          porcentaje: `${mortalityData.municipio_valor}%`,
        },
      ]);
      setFuente(mortalityData.fuente);
      setDescripcion(mortalityData.nombre_componente);
      setLoading(false);
    } catch (error) {
      console.error('Error obteniendo los datos', error);
      setLoading(false);
    }
  };
  const fetchInfantMortalityData = async () => {
    setLoading(true);
    try {
      const response = await mortalidadinfantil(municipioId);

      const infantMortalityData = response.data[0];

      setInfantMortalityData([
        {
          key: '1',
          nivel: 'Colombia',
          porcentaje: `${infantMortalityData.colombia}%`,
        },
        {
          key: '2',
          nivel: 'Cauca',
          porcentaje: `${infantMortalityData.cauca}%`,
        },
        {
          key: '3',
          nivel: 'Municipio',
          porcentaje: `${infantMortalityData.municipio_valor}%`,
        },
      ]);
      setFuente(infantMortalityData.fuente);
      setDescripcion(infantMortalityData.nombre_componente);
      setLoading(false);
    } catch (error) {
      console.error('Error obteniendo los datos', error);
      setLoading(false);
    }
  };
  const fetchcoberturavacunacionData = async () => {
    setLoading(true);
    try {
      const response = await coberturavacunacion(municipioId);

      const vaccinationCoverageData = response.data[0];

      setVacunationCoberageData([
        {
          key: '1',
          nivel: 'Colombia',
          porcentaje: `${vaccinationCoverageData.colombia}%`,
        },
        {
          key: '2',
          nivel: 'Cauca',
          porcentaje: `${vaccinationCoverageData.cauca}%`,
        },
        {
          key: '3',
          nivel: 'Municipio',
          porcentaje: `${vaccinationCoverageData.municipio_resultado}%`,
        },
      ]);
      setFuente(vaccinationCoverageData.fuente);
      setDescripcion(vaccinationCoverageData.nombre_componente);
      setLoading(false);
    } catch (error) {
      console.error('Error obteniendo los datos', error);
      setLoading(false);
    }
  };
  if (loading) {
    return <Spin />;
  }

  const chartData = {
    labels: data.map(item => item.tipo),
    datasets: [
      {
        label: 'Porcentaje',
        data: data.map(item => parseFloat(item.porcentaje)),
        backgroundColor: [
          '#FF6384',
          '#36A2EB',
          '#FFCE56',
          '#4BC0C0',
          '#9966FF',
          '#FF9F40',
        ],
      },
    ],
  };
  const infantMortalityPieData = {
    labels: infantMortalityData.map(item => item.nivel),
    datasets: [
      {
        data: infantMortalityData.map(item => parseFloat(item.porcentaje)),
        backgroundColor: [
          '#FF6384',
          '#36A2EB',
          '#FFCE56',
        ],
      },
    ],
  };

  const pieChartData = {
    labels: mortalityData.map(item => item.nivel),
    datasets: [
      {
        data: mortalityData.map(item => parseFloat(item.porcentaje)),
        backgroundColor: [
          '#FF6384',
          '#36A2EB',
          '#FFCE56',
        ],
      },
    ],
  };
  const vaccinationCoveragePieChartData = {
    labels: vaccinationCoverageData.map(item => item.nivel),
    datasets: [
      {
        data: vaccinationCoverageData.map(item => parseFloat(item.porcentaje)),
        backgroundColor: [
          '#FF6384',
          '#36A2EB',
          '#FFCE56',
        ],
      },
    ],
  };

  const chartOptions = {
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value) {
            return value + '%';
          },
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  return (
    <div  className="page-content">
      <h1>{descripcion}</h1>
      <p></p>
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        bordered
        title={() => `Aseguramiento en Salud - ${year}`}
        footer={() => (
          <div>
            <p>{`Fuente: ${fuente}`}</p>
          </div>
        )}
      />
      <div className="chart-container">
        <Bar data={chartData} options={chartOptions} />
      </div>
      <h1>Tasa de Mortalidad</h1>
      <Table
        columns={mortalityColumns}
        dataSource={mortalityData}
        pagination={false}
        bordered
        title={() => `Tasa de Mortalidad - ${year}`}
        footer={() => (
          <div>
            <p>{`Fuente: ${fuente}`}</p>
          </div>
        )}
      />
      <div className="chart-container">
        <Pie data={pieChartData} />
      </div>
      <h1>Tasa de Mortalidad Infantil</h1>
      <Table
        columns={infantMortalityColumns}
        dataSource={infantMortalityData}
        pagination={false}
        bordered
        title={() => `Tasa de Mortalidad Infantil - ${year}`}
        footer={() => (
          <div>
            <p>{`Fuente: ${fuente}`}</p>
          </div>
        )}
      />
      <div className="chart-container">
        <Pie data={infantMortalityPieData} />
      </div>
      <h2>Cobertura de Vacunación</h2>
      <Table
        columns={vaccinationCoberageColumns}
        dataSource={vaccinationCoverageData}
        pagination={false}
        bordered
        title={() => 'Cobertura de Vacunación'}
        footer={() => (
          <div>
            <p>{`Fuente: ${fuente}`}</p>
          </div>
        )}
      />
      <div className="chart-container">
        <Pie data={vaccinationCoveragePieChartData} />
      </div>
    </div>
  );
};

export default SaludComponente;
